export default {
  release: '17.5',
  date: 'October 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-5-released/#this-months-notable-contributor-jim-ender',
  contributors: [
    {
      name: 'Jim Ender',
      gitlabUsername: 'jimender2',
    },
  ],
  writeUp: `Jim was recognized for leading an effort to [close nearly 100 backlog issues](https://gitlab.com/gitlab-org/gitlab/-/issues/?sort=updated_desc&state=closed&assignee_username%5B%5D=Jimender2&first_page_size=100)
on GitLab.
He is active in many of our weekly community pairing sessions that dive into some interesting discussions.
Jim also supports people across the [GitLab Community Discord](https://discord.gg/gitlab),
troubleshooting GitLab support requests and guiding new contributors.
Jim works for an industrial technology company writing software for Critical Infrastructure and ERP systems.

"Even small contributions add up to make projects better," says Jim.
"Something as small as documentation contributions helps others out. You don't have to champion a full new feature."

Jim was nominated by [Lee Tickett](https://gitlab.com/leetickett-gitlab), Staff FullStack Engineer, Contributor Success at GitLab.
"Issue triage/curation has been toward the top of my list to get the wider community involved in and Jim is paving the way here," says Lee.

[Daniel Murphy](https://gitlab.com/daniel-murphy), Senior Program Manager, Contributor Success at GitLab, added to the nomination.
"Jim's outstanding support for new contributors and guidance in getting them started helps us grow as a community to co-create GitLab."

"Impressive work on the [merge request](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/163849) I reviewed!" says [Vanessa Otto](https://gitlab.com/vanessaotto), Senior Frontend Engineer at GitLab.
"Jim responded quickly, understood the suggestions immediately, and implemented them seamlessly.
It was great to see such efficiency and clarity in Jim's approach."

We are so grateful to Jim and all of our open source community for contributing to GitLab!`,
};
